export default {
  resourcePool: {
    projectAssetLibrary: 'Project Assets',
    publicAssetLibrary: 'Public Assets',
    projectAsset: {
      addFilter: {
        title: 'Status',
        added: 'Added',
        notAdded: 'Not Add',
      },
      bg: 'Background Image',
      bgm: 'BGM',
      bgTip: 'Please go to the Global Settings to edit the background image.',
      bgmTip: 'Please go to the Global Settings to edit the background music.',
      replace: 'Replace Asset',
      loaclUpload: 'Upload',
      fromLib: 'Add',
      chooseAsset: 'Choose from library',
      edit: 'Crop',
      clip: 'Clip',
      download: 'Download',
      delete: 'Delete',
      deleteTitle: 'Delete the Added Asset',
      deleteContent:
        'Deleting the asset that has been added to the project will also delete the corresponding layers. Are you sure you to delete?',
    },
    resource: {
      uploadForbidden: {
        type: "This template doesn't support that format.",
        play: "Gameplay template doesn't support that format. ",
      },
    },
    assetLibrary: 'Asset Library',
    myAssetLibrary: 'My Assets',
    assetTab: {
      all: 'All',
      image: 'Images',
      video: 'Video',
      audio: 'Audio',
      bgm: 'BGM',
      sound: 'Sound Effects',
      aImage: 'Motion Graphic',
      particle: 'Particle',
    },
  },
  uoload: {
    tips: 'Click or drag file to this area to upload',
    subTips: {
      video: 'Video: mp4, <{size}M',
      image: 'Image: jpg/jpeg/png, <{size}M',
      audio: 'Audio: mp3, <{size}M',
      seq: 'Sequence: zip(png), <{size}M',
      dragonBone: 'DragonBones: zip(json+png), <{size}M',
      seqSizeTip: 'Inconsistent image dimensions.',
      seqMaxSizeTip: 'Sequence size cannot exceed {size}MB.',
      seqFormatTip: 'Incorrect file format for the sequence.',
    },
  },
  upload: {
    task: {
      tips: 'Uploaded {num} / {total}',
    },
    unsupportedFileTip: 'This file type is not allowed.',
    subTips: {
      unknownError: 'Unknown error.',
    },
    acceptTip:
      '{resource} only supports "{accept}" format. <br />The following files cannot be uploaded:',
  },
  resource: {
    addToPlayable: {
      error: {
        seq: 'The asset is not a sequence.',
        particle: 'The asset is not a particle.',
        dragonBone: 'The asset is not a DragonBones.',
        dragonBoneUnsupported:
          'The template does not support adding DragonBones.',
        dragonBoneFormat:
          'DragonBones files must consist of 2 json files and 1 png file.',
      },
    },
    category: {
      contact:
        'This feature is only available for official accounts. Please contact sales.',
    },
    quickLayout: {
      error: 'Unable to add, as quick layout is already included.',
    },
    apply: {
      public: 'External',
      internal: 'Internal',
    },
  },
  project: {
    editingTip: 'The project is being edited. Please try again later.',
    notexistTip: 'Project not found under this account.',
  },
  eventSetting: {
    warnText:
      'Better not to modify the parameters of the timming trigger, they may affect the playabilities.',
    delayText:
      '"Redirect to app store" event with a delay time exceeding 1s may be intercepted. Consider reducing it to within 1s.',
    triggerDelayText:
      "If the time interval between triggering the 'Redirect to app store' event and the user's last interaction is more than 1s, it may be intercepted. Please make sure it is not too long.",
  },
  quickToolBar: {
    eventManager: {
      title: 'Custom Tracking',
      sourceTips: 'Tracking outside the current scene cannot be located.',
    },
    title: 'Quick Positioning',
  },
  textStyle: {
    update: {
      error: 'Failed to change the font.',
    },
  },
  remindDialog: {
    content:
      'Please keep the package size within the required limit for each network. Slightly exceeding the limit can be handled through compression during the download process. For details, see',
    toHelp: 'Help Center.',
    table: {
      sizeLimit: 'Package Size',
      other: 'Others',
    },
    ok: 'Got It',
  },
}
